import {
  BiBarGap,
  BiVizSpec,
  BiVizStyle,
  BiVizType,
  kBiDonutInnerRadius,
  kBiVizStyleDefaults,
} from '@euler/model/bi/viz';

/** The share of a category's band each bar gap leaves empty. */
export const kBiBarGapShares: Record<BiBarGap, number> = {
  [BiBarGap.Narrow]: 0.2,
  [BiBarGap.Normal]: 0.4,
  [BiBarGap.Wide]: 0.6,
};

type Defaults = typeof kBiVizStyleDefaults;

/** Every look option of a viz, its own or the theme's. */
export interface BiVizLook {
  title: Defaults['title'];
  subtitle: string | null;
  /** The style names whether the legend shows (else: only for several). */
  legendSet: boolean;
  legend: Defaults['legend'];
  axes: Defaults['axes'];
  gridLines: boolean;
  dataLabels: boolean;
  line: Defaults['line'];
  bar: Defaults['bar'];
  pie: Defaults['pie'];
  radar: Defaults['radar'];
  funnel: Defaults['funnel'];
  table: Defaults['table'];
  kpi: Defaults['kpi'];
}

export function biVizLook(viz: BiVizSpec): BiVizLook {
  const style: BiVizStyle = viz.style ?? {};
  const d = kBiVizStyleDefaults;
  return {
    title: { ...d.title, ...style.title },
    subtitle: style.subtitle?.trim() || null,
    legendSet: !!style.legend,
    legend: style.legend ?? d.legend,
    axes: {
      x: style.axes?.x ?? d.axes.x,
      y: style.axes?.y ?? d.axes.y,
      y2: style.axes?.y2 ?? d.axes.y2,
    },
    gridLines: style.gridLines ?? d.gridLines,
    // A funnel is read by its labels, so they show unless turned off.
    dataLabels:
      style.dataLabels ?? (viz.type === BiVizType.Funnel || d.dataLabels),
    line: style.line ?? d.line,
    bar: style.bar ?? d.bar,
    pie: style.pie ?? {
      ...d.pie,
      innerRadius: viz.type === BiVizType.Donut ? kBiDonutInnerRadius : 0,
    },
    radar: style.radar ?? d.radar,
    funnel: style.funnel ?? d.funnel,
    table: style.table ?? d.table,
    kpi: style.kpi ?? d.kpi,
  };
}
